export default "__VITE_ASSET__7pmzXt1k__"